export default __webpack_public_path__ + "static/media/rewards-dnp-cn.accecd67.webp";